module.exports = __webpack_public_path__ + "static/img/chill_out_corner.600f7008.png";